import { Heart, AirplaneTilt } from '@phosphor-icons/react';

export default function SaveTheDateCardPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#FAF8F5' }}>
      {/* Postcard Save the Date */}
      <div className="max-w-3xl w-full">
        {/* Postcard */}
        <div 
          className="relative bg-white overflow-hidden"
          style={{ 
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.2)',
            borderRadius: '4px',
          }}
        >
          {/* Front of Postcard */}
          <div className="flex flex-col md:flex-row">
            {/* Left Side - Image */}
            <div className="md:w-1/2 relative">
              <img
                src="https://customer-assets.emergentagent.com/job_coatapeque-wedding/artifacts/f5y8f5ka_ChatGPT%20Image%20Jan%2020%2C%202026%2C%2012_51_33%20PM.png"
                alt="Greetings from El Salvador"
                className="w-full h-64 md:h-full object-cover"
              />
              {/* Overlay with couple photo */}
              <div className="absolute bottom-4 right-4 w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden border-4 border-white shadow-lg">
                <img
                  src="https://customer-assets.emergentagent.com/job_coatapeque-wedding/artifacts/z82or38h_Facetune_12-11-2025-12-56-12%202.jpg"
                  alt="Stefanie and Walter"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Right Side - Postcard Message */}
            <div className="md:w-1/2 p-6 md:p-8 relative" style={{ backgroundColor: '#FFFDF9' }}>
              {/* Postcard lines background */}
              <div className="absolute inset-0 opacity-20 pointer-events-none">
                {[...Array(12)].map((_, i) => (
                  <div 
                    key={i} 
                    className="border-b"
                    style={{ 
                      borderColor: '#C9B99A',
                      height: '32px'
                    }}
                  />
                ))}
              </div>

              {/* Stamp */}
              <div className="absolute top-4 right-4 w-16 h-20 border-2 flex flex-col items-center justify-center text-center"
                   style={{ borderColor: '#C9B99A', backgroundColor: '#FFF9F0' }}>
                <AirplaneTilt size={24} style={{ color: '#C9B99A' }} className="mb-1" />
                <p className="text-xs font-bold" style={{ color: '#C9B99A' }}>2026</p>
                <p className="text-xs" style={{ color: '#B8A88A' }}>EL SALVADOR</p>
              </div>

              {/* Postmark */}
              <div className="absolute top-6 right-24 opacity-40">
                <div className="w-16 h-16 rounded-full border-2 border-dashed flex items-center justify-center"
                     style={{ borderColor: '#8B7355' }}>
                  <div className="text-center">
                    <p className="text-xs font-bold" style={{ color: '#8B7355' }}>DEC</p>
                    <p className="text-lg font-bold leading-none" style={{ color: '#8B7355' }}>11</p>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="relative z-10 pt-4">
                <p 
                  className="font-body text-xs tracking-[0.3em] uppercase mb-4"
                  style={{ color: '#B8A88A' }}
                >
                  Save the Date
                </p>

                <h1 
                  className="font-display text-2xl md:text-3xl mb-1"
                  style={{ color: '#4A4A4A' }}
                >
                  Stefanie & Walter
                </h1>

                <p className="font-body text-sm italic mb-6" style={{ color: '#8B8B8B' }}>
                  are getting married!
                </p>

                <div className="mb-6">
                  <p 
                    className="font-display text-xl mb-1"
                    style={{ color: '#C9B99A' }}
                  >
                    December 11, 2026
                  </p>
                  <p className="font-body text-sm" style={{ color: '#6B6B6B' }}>
                    Cardedeu, Lake Coatapeque
                  </p>
                  <p className="font-body text-sm" style={{ color: '#8B8B8B' }}>
                    El Salvador
                  </p>
                </div>

                <div className="flex items-center gap-2 mb-6">
                  <div className="h-px flex-1" style={{ backgroundColor: '#E8E2D9' }} />
                  <Heart size={14} weight="fill" style={{ color: '#C9B99A' }} />
                  <div className="h-px flex-1" style={{ backgroundColor: '#E8E2D9' }} />
                </div>

                <p 
                  className="font-body text-xs italic"
                  style={{ color: '#A0A0A0' }}
                >
                  Formal invitation to follow
                </p>

                <p 
                  className="font-body text-xs mt-4"
                  style={{ color: '#C9B99A' }}
                >
                  ✈ Pack your bags for a destination celebration!
                </p>
              </div>
            </div>
          </div>

          {/* Bottom edge effect */}
          <div 
            className="h-1"
            style={{ 
              background: 'repeating-linear-gradient(90deg, #C9B99A 0px, #C9B99A 10px, transparent 10px, transparent 20px)'
            }}
          />
        </div>

        {/* Caption */}
        <p className="text-center mt-8 font-body text-sm text-stone-400">
          Wish you were here... and soon you will be!
        </p>
      </div>
    </div>
  );
}
